import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import ChapterHeader from '../ChapterHeader/ChapterHeader';
import imageS from '../../assets/ch2-m.png';
import imageWebP from '../../assets/ch2-m.webp';

function Chapter2() {
  const hyperlinkData = [
    {
      copy: 'World Health Organization',
      href: 'https://www.who.int/news-room/fact-sheets/detail/blindness-and-visual-impairment',
      label: "Visit World Health Organization's Blindness and vision impairment page."
    },
    {
      copy: 'NIH',
      href: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7649735/',
      label:
        'Read article, Blindness above and below the Poverty Line: Reflections form Sofala, Mozambique.'
    },
    {
      copy: 'single wearable prototype',
      href: 'https://www.intel.com/content/www/us/en/newsroom/news/ai-powered-backpack-visually-impaired-navigate.html',
      label: 'Read article, Intel AI-Powered Backpack Helps Visually Impaired'
    },
    {
      copy: 'OpenVINO',
      href: 'https://www.intel.com/content/www/us/en/developer/tools/openvino-toolkit/overview.html',
      label: 'Visit OpenVINO™ toolkit page'
    },
    {
      copy: 'Ximira',
      href: 'https://miravisinfo.wixsite.com/mira',
      label: "Visit Ximira's home page"
    }
  ];
  return (
    <section className="chapters">
      <ChapterHeader chIndex={1} />
      <div className="chapters__body">
        <h3 className="chapters__head">
          <span className="chapters__head__number">2</span>
          <span className="chapters__head__copy">
            Helping People with Visual Impairment See in Whole New Ways
          </span>
        </h3>

        <p>
          The <Hyperlink hyperlinkData={hyperlinkData[0]} /> estimates that{' '}
          <span>
            globally, 285 million people are visually impaired, and of that group, 39 million are
            completely blind
          </span>
          . There is also a direct relationship between poverty and visual impairment in certain
          parts of the world. In fact, the <Hyperlink hyperlinkData={hyperlinkData[1]} /> found that
          90% of blind people live in developing countries in Asia and Africa.
        </p>
        <p>
          Jagadish Mahendran, an engineer, developer, and startup founder originally used AI to
          teach robots to see. But a visually impaired friend inspired him to look at other
          applications. Jagadish was troubled by the high cost and limited utility of other
          offerings in assistive tech. So he combined satellite navigation, voice activation, and AI
          Computer Vision into a <Hyperlink hyperlinkData={hyperlinkData[2]} /> that would lend a
          new set of eyes for the people who need them most. Using Intel’s{' '}
          <Hyperlink hyperlinkData={hyperlinkData[3]} /> platform to build and optimize his AI
          models for computer vision, Mahendran and his team are hard at work to bring an affordable
          build of the project to the market as soon as possible. Named{' '}
          <Hyperlink hyperlinkData={hyperlinkData[4]} /> (and previously known as just “Mira”),
          Mahendran’s prototype incorporates a backpack-housed computer and battery system, a
          vest-mounted spatial camera, and a pair of wireless headphones to provide up to eight
          hours of augmented navigation as the wearer traverses complex environments.
        </p>
        <div className="chapters__photoS chapters__photoS-2">
          <picture>
            <source srcSet={imageWebP} />
            <source srcSet={imageS} />
            <img src={imageS} alt="" />
          </picture>
        </div>
      </div>
    </section>
  );
}

export default Chapter2;
